import React from 'react';
import {
    Box,
    Heading,
    Text,
    Stack,
    SimpleGrid,
    Button,
    Image,
    Divider,
    Icon,
    List,
    ListItem,
    ListIcon,
} from '@chakra-ui/react';
import {
    FaHandsWash,
    FaTachometerAlt,
    FaLeaf,
    FaWater,
    FaRegClock,
    FaCheckCircle,
    FaExclamationTriangle,
} from 'react-icons/fa';

const sectionStyle = {
    px: { base: 6, md: 12 },
    py: { base: 12, md: 20 },
};

const ColonHydrology = () => {
    return (
        <Box fontFamily="Georgia, serif">

            {/* Hero */}
            <Box bg="#3D5940" {...sectionStyle}>
                <Box maxW="6xl" mx="auto" mt={10}>
                    <Image
                        src="/assets/images/colon-hydrotherapy.jpg"
                        alt="Colonic Hydrotherapy"
                        objectFit="cover"
                        width="100%"
                        height={{ base: '220px', md: '420px' }}
                        borderRadius="xl"
                        boxShadow="lg"
                        mb={10}
                    />
                    <Heading size="lg" color="#ffffff" textAlign="center" mb={4}>
                        Cleansing and Detoxing Your Colon
                    </Heading>
                    <Text color="#ffffff" fontSize="lg" maxW="3xl" mx="auto" textAlign="center">
                        Colonic hydrotherapy gently flushes the colon with warm, filtered water to help remove toxins and waste matter.
                        It improves digestion, reduces bloating, and supports overall gut health in a calming and hygienic setting.
                    </Text>
                </Box>
            </Box>

            {/* Benefits */}
            <Box bg="#E6E9D8" {...sectionStyle}>
                <Box maxW="6xl" mx="auto">
                    <Heading size="md" color="green.800" textAlign="center" mb={8}>
                        Benefits of Colonic Hydrology
                    </Heading>
                    <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={8}>
                        <Stack align="center">
                            <Icon as={FaHandsWash} boxSize={8} color="green.700" />
                            <Text textAlign="center">Relieves bloating and discomfort</Text>
                        </Stack>
                        <Stack align="center">
                            <Icon as={FaLeaf} boxSize={8} color="green.700" />
                            <Text textAlign="center">Supports digestion</Text>
                        </Stack>
                        <Stack align="center">
                            <Icon as={FaWater} boxSize={8} color="green.700" />
                            <Text textAlign="center">Promotes clearer skin</Text>
                        </Stack>
                        <Stack align="center">
                            <Icon as={FaTachometerAlt} boxSize={8} color="green.700" />
                            <Text textAlign="center">Reduces toxic load</Text>
                        </Stack>
                    </SimpleGrid>
                </Box>
            </Box>

            {/* How It Works */}
            <Box bg="white" {...sectionStyle}>
                <Box maxW="6xl" mx="auto">
                    <Heading size="md" color="green.800" mb={4}>
                        How a Session Works
                    </Heading>
                    <List spacing={3} fontSize="md" color="gray.700">
                        <ListItem><ListIcon as={FaRegClock} color="green.600" /> 45–60 min session in private calm space</ListItem>
                        <ListItem><ListIcon as={FaWater} color="green.600" /> Filtered warm water gently introduced</ListItem>
                        <ListItem><ListIcon as={FaCheckCircle} color="green.600" /> Waste released safely with no odor or discomfort</ListItem>
                        <ListItem><ListIcon as={FaLeaf} color="green.600" /> Post-session lightness and clarity</ListItem>
                    </List>
                </Box>
            </Box>

            {/* Who It’s For */}
            <Box bg="#F1F6EF" {...sectionStyle}>
                <Box maxW="6xl" mx="auto">
                    <Heading size="md" color="green.800" mb={4}>
                        Who Should Consider This Therapy?
                    </Heading>
                    <List spacing={2} fontSize="md" color="gray.700">
                        <ListItem><ListIcon as={FaCheckCircle} color="green.600" /> Bloating, gas, or sluggish digestion</ListItem>
                        <ListItem><ListIcon as={FaCheckCircle} color="green.600" /> Detox or cleanse preparation</ListItem>
                        <ListItem><ListIcon as={FaCheckCircle} color="green.600" /> Skin breakouts, fatigue or poor focus</ListItem>
                        <ListItem><ListIcon as={FaCheckCircle} color="green.600" /> Sedentary lifestyle and low fiber intake</ListItem>
                    </List>
                </Box>
            </Box>

            {/* Contraindications */}
            <Box bg="#FFF9F0" {...sectionStyle}>
                <Box maxW="6xl" mx="auto">
                    <Heading size="md" color="red.700" mb={4}>
                        When It's Not Recommended
                    </Heading>
                    <List spacing={2} fontSize="md" color="gray.700">
                        <ListItem><ListIcon as={FaExclamationTriangle} color="red.500" /> Severe heart or kidney disease</ListItem>
                        <ListItem><ListIcon as={FaExclamationTriangle} color="red.500" /> GI bleeding, recent rectal surgery</ListItem>
                        <ListItem><ListIcon as={FaExclamationTriangle} color="red.500" /> First trimester of pregnancy</ListItem>
                        <ListItem><ListIcon as={FaExclamationTriangle} color="red.500" /> Uncontrolled hypertension</ListItem>
                    </List>
                    <Text fontSize="sm" color="gray.600" mt={2}>
                        Always consult your physician before booking.
                    </Text>
                </Box>
            </Box>

            {/* Call to Action */}
            <Box bg="white" textAlign="center" {...sectionStyle}>
                <Box maxW="xl" mx="auto">
                    <Heading size="md" color="green.800" mb={3}>
                        Ready for Deep Detox & Gut Relief?
                    </Heading>
                    <Text mb={4} color="gray.600" fontSize="md">
                        Book your personalized colonic hydrology session today.
                    </Text>
                    <Button size="lg" colorScheme="green" px={10}>
                        Book Now
                    </Button>
                </Box>
            </Box>

            <Divider />
        </Box>
    );
};

export default ColonHydrology;
